import Vue from 'vue';
// import Vuetify from 'vuetify';
import Vuetify from 'vuetify/lib';

import cs from 'vuetify/lib/locale/cs';

import 'vuetify/dist/vuetify.min.css';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: {
      cs
    },
    current: 'cs',
  },
  theme: {
    dark: true,
    themes: {
      dark: {
        secondary: '#183556',
        background: '#222222'
      }
    }
  }
});
